import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AdministratorRoutingModule } from './administrator-routing.module';
import { FlexLayoutModule } from '@angular/flex-layout';
import { CustomMaterialModule } from '../custom-material.module';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { CKEditorModule } from '@ckeditor/ckeditor5-angular';
import { ShareModule } from '../_share/share.module';

import { AdminDefaultComponent } from './admin-default/admin-default.component';
import { CompaniesComponent, CreateCompanyDialog, ViewCompanyDialog } from './companies/companies.component';
import { UsersComponent } from './users/users.component';

@NgModule({
  declarations: [
    AdminDefaultComponent,
    CompaniesComponent, CreateCompanyDialog, ViewCompanyDialog, AdminDefaultComponent, UsersComponent
  ],
  imports: [
    CommonModule,
    FlexLayoutModule,
    CustomMaterialModule,
    ReactiveFormsModule,
    FormsModule,
    CKEditorModule,
    ShareModule,
    AdministratorRoutingModule
  ],
  providers: [],
  entryComponents: [ 
    CreateCompanyDialog, ViewCompanyDialog,
  ]
})
export class AdministratorModule { }
